import { AxiosResponse, InternalAxiosRequestConfig } from 'axios';
import { store } from '@/store/store';
import { clearStore as clearUserStore } from '@/store/reducers/user/userSlice';
import errorFactory, { ErrorResponse } from './errorFactory';
import { EXCEPTION_CODES } from '../exceptions/codes';
import { ApiException } from '../exceptions/ApiException';
import { localStorage } from '@/utils/storage';

const AUTH_CODES = [EXCEPTION_CODES.NOT_AUTHENTICATED];

export const handleSuccess = (response: AxiosResponse) => {
  return response;
};

export const handleError = (error: ErrorResponse) => {
  console.error(error);

  return Promise.reject(errorFactory(error));
};

export const handleNotAuthenticatedError = async (error: ApiException) => {
  if (AUTH_CODES.includes(error.code)) {
    store.dispatch(clearUserStore());

    localStorage.remove('accessToken');
  }

  return Promise.reject(error);
};

export const addAccessTokenHeaders = (request: InternalAxiosRequestConfig) => {
  const accessToken = localStorage.get('accessToken');

  request.headers.set('Authorization', accessToken);

  return request;
};

export const transformResponse = (data: string) => {
  const response = JSON.parse(data);

  if (response.status === 0) {
    throw response.error;
  }

  return response;
};
